import React, {useState, useEffect} from 'react'
import './TopPage.css';
import GlobalFooter from '../common/GlobalFooter';
import GlobalHeader from '../common/GlobalHeader';
import ArticleCard from '../common/ArticleCard';

const TopPage: React.FC = () => {
    const [articles, setArticles] = useState([])

    useEffect(() => {
        const fetchArticleAsync = async () => {
            const response = await fetch('/articles/_index.json')
            const data = await response.json()
            setArticles(data.articles);
        };
        fetchArticleAsync();
    }, []);

    const listArticles = articles.map(({id, title, eyecatch, timestamp, tags}) => {
        return (
                <div className="article-card-frame" key={id}>
                    <ArticleCard
                        title={title}
                        link={'/articles/' + id}
                        eyecatch={eyecatch}
                        timestamp={timestamp}
                        tags={tags}
                    />
                </div>
            )
        }
    )

    return (
        <div className="toppage-root">
            <GlobalHeader />
            <div className="toppage-container">
                <div className="toppage-title">
                    <h1>Rocinax Laboratory</h1>
                </div>
                <div className="article-list-space">
                    {listArticles}
                </div>
            </div>
            <GlobalFooter />
        </div>
    );
}

export default TopPage;